import { gql } from '@apollo/client';

export const GET_TEAM = gql`
  query GET_TEAM($projectId: ID!, $ids: [ID!]) {
    team(projectId: $projectId, ids: $ids) {
      id
      user {
        id
        name
        netId
        faculty {
          id
          abbreviation
        }
        department {
          id
          abbreviation
          faculty {
            id
            abbreviation
          }
        }
      }
      teamMemberType {
        id
        name
        seq
      }
    }
  }
`;

export const ADD_TEAM_MEMBER = gql`
  mutation ADD_TEAM_MEMBER($input: AddTeamMemberInput!) {
    addTeamMember(input: $input) {
      user {
        name
      }
    }
  }
`;

export const UPDATE_TEAM_MEMBER = gql`
  mutation UPDATE_TEAM_MEMBER($input: UpdateTeamMemberInput!) {
    updateTeamMember(input: $input) {
      user {
        name
      }
    }
  }
`;
export const DELETE_TEAM_MEMBER = gql`
  mutation DELETE_TEAM_MEMBER($input: DeleteTeamMemberInput!) {
    deleteTeamMember(input: $input)
  }
`;
